import React from "react";
import ReactDOM from "react-dom/client";
import "./style.css";   // ortak stiller önce yüklenmeli
import App from "./App";  // App.js'deki App componentini alıyoruz

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


